import { render } from "./HeroiconsSolidWifi.vue?vue&type=template&id=bf3b1d00"
const script = {}

import exportComponent from "/home/harlan/sites/kintell-env/api/packages/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidWifi.vue"]])

export default __exports__